import UserManagementForm from "@/components/Forms/UserManagementForm";

const PersonalInformationUpdate = () => {
    return (
        <UserManagementForm page='profile'/>
    )
}

export default PersonalInformationUpdate;